function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "pl-icon-mobile");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "pl-icon-mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "pl-icon-final"
}, React.createElement("rect", {
  id: "Rectangle",
  fill: "#007DDA",
  x: 0,
  y: 0,
  width: 25,
  height: 25,
  rx: 1.953125
}), React.createElement("g", {
  id: "Group-9",
  transform: "translate(5.468750, 5.273438)"
}, React.createElement("g", {
  id: "Rectangle-+-Rectangle-Mask",
  transform: "translate(1.000000, 5.000000)"
}), React.createElement("path", {
  d: "M3.41796875,10.9375 L9.765625,10.9375 L9.765625,10.9375 L8.03002068,14.0615878 C7.92524991,14.2501752 7.68743612,14.318122 7.49884873,14.2133512 C7.48331701,14.2047225 7.46839211,14.1950441 7.454178,14.1843835 L3.359375,11.1132812 C3.31622775,11.0809208 3.30748332,11.0197097 3.33984375,10.9765625 C3.35828656,10.9519721 3.38723073,10.9375 3.41796875,10.9375 Z",
  id: "Rectangle",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M13.5742187,5.46875 C13.7129063,5.46875 13.8290861,5.56511728 13.85945,5.6945437 L13.8684836,5.77535149 C13.2923292,7.63110219 11.4985727,8.984375 9.375,8.984375 L6.77433922,8.984375 C6.41169159,8.984375 6.06052101,8.86903969 5.78192738,8.65843617 L1.79473435,5.64430811 C1.75171034,5.61178401 1.74319848,5.55054016 1.77572259,5.50751615 C1.79417997,5.48310009 1.82301694,5.46875 1.85362445,5.46875 L13.5742187,5.46875 Z",
  id: "Path",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M9.375,0 C11.4985727,0 13.2923292,1.35327281 13.8684836,3.20902351 L13.8671875,3.22265625 C13.8671875,3.38445842 13.7360209,3.515625 13.5742188,3.515625 L5.21646734,3.515625 C4.85349767,3.515625 4.50201526,3.40028969 4.22317424,3.18968617 L0.232473853,0.175583245 C0.189435962,0.143077514 0.18089796,0.0818373085 0.21340369,0.0387994179 C0.231859486,0.0143637723 0.260708517,0 0.291330685,0 L9.375,0 Z",
  id: "Path",
  fill: "#FFFFFF"
}))));

var SvgPlIconMobileFinal = function SvgPlIconMobileFinal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlIconMobileFinal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pl-icon-mobile-final.644e5726.svg";
export { ForwardRef as ReactComponent };